import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataContext } from '../../../../home/pages/automs/autom/FlowConfiguration';
import Button from "@material-ui/core/Button";
import { isActionValueController } from "../../../../helpers/helper";
import AutomService from "../../../../services/AutomService/AutomService";
import { makeStyles } from "@material-ui/core/styles";
import { Checkboxes } from "../../../FlowConfigurationInputs";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
const useStyles = makeStyles((theme) => ({
    hiddenImage: {
        display: "none"
    },
    visibleImage: {
        display: "block"
    }
}));
/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @param       variables - object variable list
 * @param       setOpenVariable - open variable function that allows us to open
 * @param       variableRenbder - variable render
 * @param       showAlert -  show alert
 * @param       recorder
 * @param       setRender
 * @param       automId
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Scope({ action, variables, setOpenVariable, showAlert, recorder, setRender, automId, automVersionId }) {
    const classes = useStyles();
    const [scopedImage, setScopedImage] = useState("");
    const [scopeImageClass, setScopeImageClass] = useState(classes.hiddenImage);
    const { t } = useTranslation();
    useEffect(() => {
        if (!action.fields.sameURL) {
            action.fields.sameURL = { value: Math.floor(Math.random() * 1000) }
        }
        if (!action.fields.getSS) {
            action.fields.getSS = { value: "" }
        } else {
            setScopedImage(action.fields.getSS.value);
            setScopeImageClass(classes.visibleImage)
        }
    }, [action, variables])
    const label = 'CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.SCOPE.';
    const context = useContext(DataContext);
    const options = {
        checkbox0: { label: label + 'MINIMIZE' }
    }
    async function handleGetSS() {
        let res = isActionValueController(action.fields);
        if (res.indexOf(false) === -1) {
            let manipulatedAction = JSON.parse(JSON.stringify(action));
            manipulatedAction.children = [];
            manipulatedAction.automId = automId;
            manipulatedAction.automVersionId = automVersionId;
            let response = await AutomService.runAction(manipulatedAction);
            if (response) {
                if (response && response.dataString) {
                    setScopedImage("data:image/jpeg;base64," + response.dataString)
                    action.fields.getSS.value = "data:image/jpeg;base64," + response.dataString;
                    setScopeImageClass(classes.visibleImage)
                }
                if (response && response.message.includes("System Error:")) {
                    showAlert(response.message.replace("System Error:", ""), response.status);
                } else {
                    showAlert(t("FLOW-MESSAGES.LIBRARY." + response?.message), response.status);
                }
            }
        } else {
            showAlert(t("ACTIVE-DIRECTORY.NOT-NULL"), false);
        }
    }
    return (
        <div>
            <div className="form-element">
                {/* {t(label + 'GET-S')} : &nbsp; */}
                <Button
                    variant="outlined"
                    onClick={handleGetSS}
                    style={{
                        background: "#031226",
                        boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
                        borderRadius: 4,
                        color: "#fff",
                        fontWeight: 700
                    }}
                >
                    {t(label + "GET-SS")}
                </Button>
            </div>
            <div className="form-element">
                {scopedImage.length > 1 ?
                    <img src={scopedImage} alt="Scoped Image" style={{ width: "100%" }} className={scopeImageClass} />
                    : null
                }
            </div>
            <div className="form-element">
                <Checkboxes action={action} inputName="minimize" options={options.checkbox0} />
            </div>
            <div className="form-element">
                {t(label + "EVENT-DELAY")}
                <TextInput
                    action={action}
                    isRequired={false}
                    inputName="eventDelay"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            </div>
        </div>
    );
}
export default Scope;